// مصدر واحد للتحكّم بإظهار الأسعار/المبالغ حسب الدور (تجميع canViewPrices المكرّر).
// تظهر الأسعار فقط لـ: مدير النظام (1) + المالك (3) + المحاسب (7).
// الأدوار الإكلينيكية (طبيب/طبيب إنتاج/بيطار/مدرّب) لا ترى الأسعار.
export const PRICE_VISIBLE_ROLE_IDS = [1, 3, 7];

export function canViewPrices() {
  const roleId = Number(localStorage.getItem('role_id') || 0);
  return PRICE_VISIBLE_ROLE_IDS.includes(roleId);
}

export default canViewPrices;
